import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiAxios from "helpers/apiAxios";
import { toast } from "react-toastify";
import { addRejectedMatcher, handleAsyncThunkError } from "redux/reduxHelpers";

import {
  initialState,
  handleFulfilled,
  setNestedPageHelper,
  setNestedPageSizeHelper,
  setNestedParamsHelper,
  resetNestedParamsHelper,
  setSortParamsHelper,
  setFilterTagHelper,
  resetFilterTagHelper,
  handlePayload
} from "helpers/reducerHelpers";

const scheduleUrl = "/crm/project/schedules";

export const getProjectSchedules = createAsyncThunk(
  "ProjectSchedule/getProjectSchedules",
  async (params) => {
    try {
      const response = await apiAxios.get(scheduleUrl, { params } )
      return response.data
    }
    catch(error) {
      throw new Error(error.message)
    }
  }
)

export const updateSchedule = createAsyncThunk(
  "ProjectSchedule/updateSchedule",
  async ({ phaseId, data }, { rejectWithValue }) => {
    try {
      const response = await apiAxios.put(`${scheduleUrl}/${phaseId}/pmd_update`, data)
      return response.data
    }
    catch(error) {
      return rejectWithValue(handleAsyncThunkError(error, 'Failed to update schedule'));
    }
  }
)

export const exportData = createAsyncThunk(
  "ProjectSchedule/exportData",
  async (params, { rejectWithValue }) => {
    try {
    //remove page and per_page in object
    const { page, per_page, ...rest } = params
    console.log(rest, page, per_page)

    const response = await apiAxios.get(`${scheduleUrl}/export`, {params, responseType: 'blob'})
    
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `project-schedule.xlsx`);
    document.body.appendChild(link);
    link.click();
    }
    catch(error) {
      return rejectWithValue(handleAsyncThunkError(error, 'Failed to export data'));
    }
  }
)

const scheduleSlice = createSlice({
  name: "crm_project_schedule_pmd",
  initialState: {
    ...initialState
  },
  reducers: {
    setNestedPage: setNestedPageHelper,
    setNestedPageSize: setNestedPageSizeHelper,
    setNestedParams: setNestedParamsHelper,
    resetNestedParams: resetNestedParamsHelper,
    setSortParams: setSortParamsHelper,
    setFilterTag: setFilterTagHelper,
    resetFilterTag: resetFilterTagHelper
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProjectSchedules.fulfilled, (state, action) => handleFulfilled(state, action, "allData"))
      .addCase(updateSchedule.fulfilled, (state, action) => {
        handlePayload(state, action)
      })
      .addCase(exportData.pending, (state) => {
        state.exporting = true
      })
      .addCase(exportData.fulfilled, (state) => {
        state.exporting = false
        toast.success("Data has been exported successfully.")
      })

      // Add standard rejected action matcher using shared helper
      addRejectedMatcher(builder, "ProjectSchedule");
  }
})

export const {
  setNestedPage,
  setNestedPageSize,
  setNestedParams,
  resetNestedParams,
  setSortParams,
  setFilterTag,
  resetFilterTag
} = scheduleSlice.actions

export default scheduleSlice.reducer